import { Icon } from '@livable/saas-react-components';
import { Button, Paper, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import BreadcrumbsList from 'src/components/general/BreadcrumbsList';
import Separator from 'src/components/general/Separator';
import useStyles from './styles';
export default function NotificationBlock(_ref) {
  let _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Separator, {
    text: "Date 02/20/2022"
  }), data.notificationsByType.map(notificationsData => /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper",
    key: notificationsData.time
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.time
  }, notificationsData.time), notificationsData.type === 'credentials-outdated' && /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, "It looks like the utility provider credentials are outdated. Update them prior next billing cycle for bill acquisition to work correctly."), notificationsData.type === 'bill-spike-alert' && /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, "Bill spike alert! Some of the utility bills are exceeding the expected values. Would you please review your bill values?"), notificationsData.type === 'new-billing-cycle' && /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, "New billing cycle has started. Please do not forget to upload your bills."), notificationsData.type === 'balance-overdue' && /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, "There are overdue balances across your X properties. Our system will automatically send a late fee reminder one day prior Late fee assessment. But you can trigger a balance reminder for your residents at any time."), notificationsData.type === 'monthly-reports-ready' && /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, "Your monthly reports are ready!"), /*#__PURE__*/React.createElement("div", {
    className: classes.notificationsList
  }, notificationsData.notifications.map(breadcrumbsArray => /*#__PURE__*/React.createElement("div", {
    className: classes.notification,
    key: notificationsData.id
  }, /*#__PURE__*/React.createElement(BreadcrumbsList, {
    size: "h5",
    breadcrumbsArray: breadcrumbsArray
  }), notificationsData.type === 'credentials-outdated' && /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '695-notifications-page-tab'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "lock-unlocked"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Update credentials")), notificationsData.type === 'bill-spike-alert' && /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '696-notifications-page-tab'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "show-eye-on"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Review bills")), notificationsData.type === 'new-billing-cycle' && /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    component: RouterLink,
    to: "/allocation_tables",
    'custom-attribute': '697-notifications-page-tab'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "table"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Open allocation tables")), notificationsData.type === 'balance-overdue' && /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '698-notifications-page-tab'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "message"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Send balance reminder")), notificationsData.type === 'monthly-reports-ready' && /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '699-notifications-page-tab'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "file-download"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Download report"))))))));
}
NotificationBlock.propTypes = {
  data: PropTypes.shape({
    date: PropTypes.string,
    notificationsByType: PropTypes.arrayOf(PropTypes.shape({
      time: PropTypes.string,
      type: PropTypes.string,
      notifications: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string,
        link: PropTypes.string
      })))
    }))
  })
};